export default function Navigation()
{
    return (<ul className="d-flex ms-auto flex-row header__nav mb-xl-0 navbar-nav">
        <li className="nav-item"></li>
        <a className="bs-link nav-link" href="#">Новинки</a>

        <li className="nav-item">
            <a className="bs-link nav-link" href="#">Акции</a>
        </li>
        <li className="nav-item">
            <a className="bs-link nav-link" href="#">Оплата</a>
        </li>
        <li className="nav-item">
            <a className="bs-link nav-link" href="#">Доставка</a>
        </li>
        <li className="nav-item">
            <a className="bs-link nav-link" href="#" aria-disabled="true">Обмен и
                возврат</a>
        </li>
        <li className="nav-item">
            <a className="bs-link nav-link" href="#">Контакты</a>
        </li>
    </ul>)
}